/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.hero-banner' ).each( function( key, component ) {
        if ( $( component ).find( '.splide--hero-banner' ).length ) {
          const splide = new Splide( $( component ).find( '.splide--hero-banner' )[0], {
            type: 'loop',
            pagination: false,
            arrows: false,
            gap: '32px',
            autoWidth: true,
            autoScroll: {
              speed: 0.75,
            },
          } );

          splide.mount( {AutoScroll} );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
